import React from "react";
import { useDispatch } from "react-redux";
import { setPatientsQueryParams } from "../../redux/modules/patient/actions";

const Pagination = ({ paginationRange, activePage, totalPages }) => {
  const dispatch = useDispatch();

  const handlePageChange = (newPage) => {
    dispatch(setPatientsQueryParams({ page: newPage }));
  };

  return (
    <div className="flex items-center justify-center px-4 py-4 border-t border-gray-50 bg-gray-10 sm:px-6">
      <div className="">
        <div>
          <nav
            className="inline-flex space-x-3 rounded-md isolate"
            aria-label="Pagination"
          >
            {totalPages > 0 && (
              <button
                onClick={() =>
                  handlePageChange(activePage === 1 ? 1 : activePage - 1)
                }
                className={`relative inline-flex items-center px-4 py-2 bg-white font-semibold shadow rounded-[4px] 
                ${ activePage === 1
                    ? "text-gray-100 cursor-not-allowed"
                    : "text-gray-800"
                }`}
              >
                Previous
              </button>
            )}
            {paginationRange?.map((item, index) => (
              <React.Fragment key={index}>
                {item === "..." ? (
                  <span className="relative inline-flex items-center bg-white px-4 py-2 text-gray-800 font-semibold shadow rounded-[4px]">
                    ...
                  </span>
                ) : (
                  <button
                    onClick={() => handlePageChange(item)}
                    className={`relative inline-flex items-center ${
                      activePage === item
                        ? "bg-REELTeal text-white"
                        : "bg-white text-gray-800"
                    } px-4 py-2 font-semibold shadow rounded-[4px]`}
                  >
                    {item}
                  </button>
                )}
              </React.Fragment>
            ))}
            {totalPages > 0 && (
              <button
                onClick={() =>
                  handlePageChange(
                    totalPages === activePage || totalPages === 0
                      ? totalPages
                      : activePage + 1
                  )
                }
                className={`relative inline-flex items-center px-4 py-2 bg-white font-semibold shadow rounded-[4px] 
                ${totalPages === activePage || totalPages === 0
                    ? "text-gray-100 cursor-not-allowed"
                    : "text-gray-800"
                }`}
              >
                Next
              </button>
            )}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
